<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Locked Customers</div>
        <div>
          <bread-crumb :bread-crumbs="['Locked Customers']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-row class="">
          <v-btn
            depressed
            @click="downloadExcelsheet"
            class="ms-3"
            color="primary"
            small
            ><v-icon small>mdi-file-excel-outline</v-icon>Export
          </v-btn>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              class="me-4"
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :search="search"
          :items="customerLocked"
          sort-by="calories"
          dense
          class="mt-4 p-1"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon
              title="Customer Locked"
              v-if="item.is_locked"
              small
              class="mr-2"
              color="primary"
              @click="editItem(item)"
            >
              mdi-lock
            </v-icon>
            <v-icon
              v-else
              title="Customer Unlocked"
              small
              class="mr-2"
              color="primary"
              @click="editItem(item)"
            >
              mdi-lock-open-variant
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
      <v-dialog persistent v-model="dialog" max-width="700px">
        <v-card>
          <v-card-title>
            <v-row>
              Unlock Customer
              <v-spacer></v-spacer>
              <v-btn depressed icon>
                <v-icon @click="dialog = false"> mdi-close </v-icon></v-btn
              >
            </v-row>
          </v-card-title>
          <v-divider class="mt-0"></v-divider>
          <v-card-text class="mt-3">
            <v-form v-model="valid" ref="unlock">
              <v-row
                ><label class="my-0 labelFontsize"> Full Name</label></v-row
              >
              <v-row>
                <v-text-field
                  placeholder=" Full Name"
                  class="rounded"
                  required
                  outlined
                  dense
                  :disabled="true"
                  v-model="lockedCustomers.full_name"
                >
                </v-text-field>
              </v-row>
              <!-- <v-row><label class="my-0 labelFontsize"></label>Status</v-row>
              <v-row>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  v-model="lockedCustomers.lock_status"
                  :rules="[(v) => !!v || 'Required']"
                  :items="[
                    { text: 'Locked', value: true },
                    { text: 'Unlocked', value: false },
                  ]"
                ></v-autocomplete>
              </v-row> -->
              <v-row><label class="my-0 labelFontsize">Remarks</label></v-row>
              <v-row>
                <v-textarea
                  outlined
                  class="rounded"
                  :rules="[(v) => !!v || 'Required']"
                  placeholder="Please provide the reason"
                  v-model="lockedCustomers.remarks"
                ></v-textarea
              ></v-row>
            </v-form>
          </v-card-text>
          <v-divider class="pa-0 ma-0"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              dense
              small
              depressed
              title="Unlock Customer"
              class="text-capitalize ms-10"
              color="primary"
              @click="updateLockedCustomers()"
            >
              <v-icon small left> mdi-lock-open-variant </v-icon>Unlock Customer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card-actions>
        <OverlayPageVue :showOverlay="loaderOverlay" />
      </v-card-actions>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import userService from "@/services/UserService/userService.js";
import alerts from "@/mixins/alerts";
// import { alpha } from "@/utils/validate"
export default {
  mixins: [alerts],
  name: "Locked Customers",
  data: () => ({
    dialog: false,
    valid: false,
    search: "",
    loaderOverlay: false,
    customerLocked: [],
    headers: [
      {
        text: "Customer ID",
        sortable: false,
        value: "user_id",
      },
      { text: "Customer Name", value: "full_name" },
      { text: "User Name", value: "user_name" },
      { text: "Email", value: "email_id" },
      { text: "phone", value: "mobile_number" },
      { text: "Last Login Date", value: "last_login_date" },
      { text: "Login wrong attempts", value: "login_wrong_attempts" },
      { text: "Ip Address", value: "ip_address" },
      { text: "Reason", value: "locked_reason" },
      { text: "Action", value: "actions", sortable: false },
    ],
    lockedCustomers: {
      full_name: "",
      user_id: null,
      lock_status: null,
      remarks: "",
    },
  }),

  components: {
    BreadCrumb,
    OverlayPageVue,
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.getLockedCustomers();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.customerLocked) {
        this.exportToExcel(
          this.headers,
          this.customerLocked,
          "Locked_customers"
        );
      }
    },
    async getLockedCustomers() {
      this.loaderOverlay = true;
      try {
        const params = {
          skip: 0,
          limit: 500000,
        };
        const response = await userService.getLockedCustomerslog(params);
        if (response.status === 200) {
          this.customerLocked = response.data.data;
          console.log("customerLocked", this.customerLocked);
          this.stoploader();
        } else {
          this.customerLocked == [];
          this.stoploader();
        }
      } catch (error) {
        this.customerLocked = [];
        this.stoploader();
        console.error(error);
      }
    },
    editItem(item) {
      console.log(item);
      this.loaderOverlay = true;
      if (item) {
        this.loaderOverlay = false;
        this.lockedCustomers.full_name = item.full_name;
        this.lockedCustomers.user_id = item.user_id;
        this.lockedCustomers.remarks = item.remarks;
        this.dialog = true;
      }
    },
    async updateLockedCustomers() {
      if (this.$refs.unlock.validate()) {
        try {
          const responseData = await userService.updateLockedCustms(
            this.lockedCustomers.user_id,
            false,
            this.lockedCustomers.remarks,
            this.lockedCustomers
          );
          if (responseData.data.status_code == 200) {
            console.log("response", responseData);
            this.dialog = false;
            this.showAlertSuccess("Customer status updated successfully");
            this.getLockedCustomers();
          } else {
            this.showAlertError("Failed: " + responseData.data.message);
          }
        } catch (error) {
          this.showAlertError("Failed: Something went wrong");
          console.log(error.response);
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
